import React, { useEffect, useCallback } from 'react'
import Quagga from '@ericblade/quagga2'
import PropTypes from 'prop-types'

const defaultDecoder = ['code_128_reader']

function BarcodeScanner({ isStart, setIdScanUpdate, constraints, decoder }) {
  const _onDetected = (res) => {
    setIdScanUpdate(res.codeResult.code)
  }

  const startScanner = useCallback(() => {
    navigator.mediaDevices.enumerateDevices().then((devices) => {
      var cameraId = null
      devices.forEach(function (device) {
        if (
          device.kind === 'videoinput' &&
          device.label.toLowerCase().indexOf('back') !== -1
        ) {
          cameraId = device.deviceId
        }
      })
      Quagga.init(
        {
          inputStream: {
            type: 'LiveStream',
            target: document.querySelector('#scanner-container'),
            constraints: {
              ...constraints,
              ...(cameraId && { deviceId: cameraId }),
            },
          },
          numOfWorkers: 0,
          locate: false,
          frequency: 1,
          debug: false,
          multiple: true,
          decoder: {
            readers: decoder || defaultDecoder,
          },
        },
        (err) => {
          if (err) {
            return console.log(err)
          }
          Quagga.start()
        }
      )
      Quagga.onDetected(_onDetected)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const stopScanner = () => {
    Quagga.offProcessed()
    Quagga.offDetected()
    Quagga.stop()
  }

  useEffect(() => {
    if (isStart) startScanner()
    else stopScanner()
    return () => {
      stopScanner()
    }
  }, [isStart, startScanner])

  return <>{isStart && <div id="scanner-container" />}</>
}

BarcodeScanner.propTypes = {
  isStart: PropTypes.bool.isRequired,
  setIdScanUpdate: PropTypes.func.isRequired,
  constraints: PropTypes.object.isRequired,
  decoder: PropTypes.array,
}

export default BarcodeScanner
